import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-item-container',
  templateUrl: './menu-item-container.component.html',
  styleUrls: ['./menu-item-container.component.scss']
})
export class MenuItemContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/menu-item-container/menu-item-container.component.ts